import { Form, Input, Tooltip } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../../components/DraggableModal";
import { EntDirection } from "../../../../models/handBooks/direction";
import { aliasText } from "../../../../utils";

enum FormField {
    nameKy,
    alias,
    nameRu
}
interface IProps {
    show: boolean;
    direction: EntDirection;
    onHide: () => void;
    onSubmit: (pos: EntDirection) => Promise<boolean>;
}

export const AddDirectionModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);


    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);


    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.direction.nameKy },
            { name: FormField.nameRu, value: props.direction.nameRu },
            { name: FormField.alias, value: props.direction.alias },
        ]);
    }

    const setEntityFromFields = (): EntDirection => {
        let diection = _.cloneDeep(props.direction);
        diection.nameKy = form.getFieldValue(FormField.nameKy);
        diection.nameRu = form.getFieldValue(FormField.nameRu);
        diection.alias = form.getFieldValue(FormField.alias);
        return diection;
    }

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            const data = setEntityFromFields();
            
            const result = await props.onSubmit(data);

            if (result) props.onHide();
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.direction.id === 0 ? t('handbooks.direction.add_direction') : t('handbooks.direction.edit_direction')}
                visible={props.show}
                onCancel={props.onHide}
                onSubmit={handleSubmit}
                submitLoading={loading}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Tooltip title={aliasText} >
                        <Form.Item
                          label={t('general.alias')}
                          name={FormField.alias}
                          rules={[{ required: true, message: t("msg.fill_in_the_field") }]}

                        >
                            <Input maxLength={255} showCount autoComplete="off" />
                        </Form.Item>
                    </Tooltip>
                    <Form.Item
                        label={t('general.nameKy')}
                        name={FormField.nameKy}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>

                    <Form.Item
                        label={t('general.nameRu')}
                        name={FormField.nameRu}
                        rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                    >
                        <Input autoComplete="off" />
                    </Form.Item>
                </Form>
            </DraggableModal>
        </>
    )
}
